// extracted by mini-css-extract-plugin
export default {"coinsDiv":"offer_coinsDiv__0tJLx","price":"offer_price__JYzmH","bonusPrice":"offer_bonusPrice__eDyak","bonus":"offer_bonus__HALgO","button":"offer_button__CZNAO"};